module.exports = __webpack_public_path__ + "static/media/kitchen.65543a8d.svg";